import { connect } from 'react-redux'

import { MarketVendorPricingAgreements } from '@components/market/edit/sections'

import services from '@services'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'
import { VendorPricingAgreement } from '@types'

interface State {
  marketVendorPricingAgreements: VendorPricingAgreement[] | null
}

const mapStateToProps = (state: State) => {
  return {
    vendorPricingAgreements: state.marketVendorPricingAgreements,
  }
}

const mapDispatchToProps = () => {
  const { RestService, UIService, VendorPricingAgreementsService } = services
  const { GetMarketVendorPricingAgreements, ShowEditVendorPricingAgreement } =
    coordinators

  const getMarketVendorPricingAgreements = GetMarketVendorPricingAgreements({
    RestService,
    VendorPricingAgreementsService,
    HandleError,
  })

  const editVendorPricingAgreement = ShowEditVendorPricingAgreement({
    UIService,
    VendorPricingAgreementsService,
  })

  return {
    getMarketVendorPricingAgreements,
    editVendorPricingAgreement,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarketVendorPricingAgreements)
